import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button-partners'
import heroImage from '@/assets/hero-album.webp'

const IntroSection = () => {
  return (
    <section className="w-full py-16 md:py-24 lg:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.5fr] gap-12 lg:gap-16 items-center">
          {/* Texto à esquerda */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <div className="space-y-1">
              <h1 className="font-serif text-2xl md:text-3xl lg:text-4xl font-normal italic text-foreground leading-tight">
                Fotografia que conecta
              </h1>
              <h2 className="font-serif text-xl md:text-2xl lg:text-3xl italic text-accent leading-tight font-normal">
                PARCERIA QUE VALORIZA
              </h2>
            </div>

            <p className="text-base md:text-lg text-foreground font-serif leading-relaxed">
              Ao se tornar parceiro, você transforma a experiência do seu
              cliente em memórias físicas que emocionam e ainda recebe uma
              participação sobre cada álbum vendido, valorizando seu trabalho e
              enriquecendo sua entrega.
            </p>

            <div className="pt-2">
              <Button size="lg" asChild>
                <a href="/parcerias/cadastro">Quero ser parceiro</a>
              </Button>
            </div>
          </motion.div>

          {/* Espaço para imagem à direita */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative rounded-lg overflow-hidden"
          >
            <img
              src={heroImage}
              alt="Álbuns FotoLivro Store para diversas ocasiões"
              className="w-full h-auto object-contain rounded-lg"
            />
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default IntroSection
